import React, { useMemo } from "react";

import { Agent } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";
import { BalanceOutput } from "../../../../../../../../../../components";

const BalanceCellContent: React.FC<BalanceCellContent.Props> = ({ item }) => {
	const content = useMemo(() => item.paymentAccounts, [item.paymentAccounts]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			<BalanceOutput value={content} balanceType="main" />
		</CellContentRoot>
	);
};

declare namespace BalanceCellContent {
	interface Props {
		item: Agent.Model;
	}
}

export default BalanceCellContent;
